const CONFIG = {
  QMATH_CONFIG_STORE_NAME: 'qmath-config',
};

export default CONFIG;
